import { TextField } from '@mui/material'
import { styled } from '@mui/material/styles'

export const TextInput = styled(TextField)({
  '&.MuiTextField-root': {
    '.MuiInputBase-root': {
      '.MuiInput-input': {
        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0,
        },
      },
    },
  },
})
